<template>
  <div  style="height: 0px; overflow: hidden;">
  <!-- <div> -->
    <div class="pdf-row" id="pdfTest">
      <div class="top">用章申请审批单</div>
      <barcode 
        class="barcode" 
        :value="info.eventId" 
        width="1" 
        height="30" 
        background="transparent"
        :displayValue="true"
        fontSize="14"
      ></barcode>
      <div class="date">申请日期：{{this.info.createTime}}</div>
      <el-row class="table-row">
        <!-- <el-col :span="4" class="border-left border-top">申请编号</el-col>
        <el-col :span="8" class="border-left border-top">{{this.info.feeType}}</el-col> -->
        <el-col :span="4">申请编号：</el-col>
        <el-col :span="8" class="border-left">{{this.info.eventId}}</el-col>
        <el-col :span="12" class="border-left">用章类型：{{this.info.stampType}}</el-col>
        <!-- <el-col :span="8" class="border-left">{{this.info.stampType}}</el-col> -->
        <el-col :span="24" class="border-top">用章原因：{{this.info.applyReason}}</el-col>
        <el-col :span="4"  class="amount border-top"><div>所属公司</div></el-col>
        <el-col :span="20" class="amount-value border-left border-top"> {{this.info.companyName}}</el-col>
        <el-col :span="4" class="amount border-top"><div>申请部门：</div></el-col>
        <el-col :span="8" class="amount-value border-left border-top"> {{this.info.deptName}}</el-col>
        <el-col :span="4" class="amount border-left border-top"><div>经办人：</div></el-col>
        <el-col :span="8" class="amount-value border-left border-top"> {{this.info.applyUser}}</el-col>

        <el-col v-for="(item,index) in auditProcessEntityList" :key="index" class="border-top"  style="padding:0;display: flex;">
          <!-- :style="{height: approvalHeight + 'px', padding:0}" -->
          <el-col :span="12"  ref="approvalLeft"  style="padding:0;display: flex;align-items: center;">
            <el-col :span="8" class="amount" style="padding:0"><div>{{(item.status == 20 || item.status == 21) ? '提交人：' : '审核人：'}}</div></el-col>
            <el-col :span="16" class="amount-value border-left" style="display: flex;align-items: center;height:100%"> {{item.auditPerson}}</el-col>
          </el-col>
          <el-col :span="12" class="border-left" ref="approvalRight"  style="padding:0;display: flex;align-items: center;padding:0">
            <el-col :span="8" class="amount" v-if="!([20, 21].includes(item.status))"><div>审核意见/时间：</div></el-col>
            <el-col :span="16" class="border-left" v-if="!([20, 21].includes(item.status))">
                <div> 时间：{{item.createTime}}</div>
                <div style="word-break:break-word"> 意见：{{item.remark }}</div>
            </el-col>
            <el-col :span="8" class="amount" v-if="[20, 21].includes(item.status)"><div>提交时间：</div></el-col>
            <el-col :span="16" class="border-left" v-if="[20, 21].includes(item.status)">
                <div> 时间：{{item.createTime}}</div>
            </el-col>
          </el-col>
        </el-col>
        <el-col :span="24" class=" border-top" style="height: 100px">备注：</el-col>
      </el-row>
      <div style="font-size: 16px; padding: 20px 50px;">会议纪要编号由行政办填写，请示报告填写编号</div>
    </div>
  </div>
</template>
<script>
import { cnMoneyFormat, htmlToPdf } from '@/utils/util'
import { getApplyDetail } from '@/api/compApplyStamp'
export default {
  data () {
    return {
      checked: true,
      info: {
        eventId: '',
        stampType: '',
        applyReason: '',
        applyUser: '',
        companyName: '',
      },
      approvalHeight: 0,
      auditProcessEntityList: [
        {
          auditPerson: '姜旭',
          createTime: '2022-09-10'
        }
      ],
    }
  },
  mounted() {
  },
  methods: {
    async getDetails (id) {
      const res = await getApplyDetail({ id })
      const { code, result } = res
      if (code !== 0) return
      console.log(res);
      this.info = {
        createTime: (result.createTime || '').substring(0, 10),
        eventId: result.eventId,
        stampType: result.stampType,
        applyReason: result.applyReason,
        applyUser: result.applyUser,
        roleName: result.userInfo?.roleName || '',
        deptName: result.deptName || '',
        companyName: result?.companyName || '-'
      }
      this.auditProcessEntityList = result.auditProcessEntityList
      this.approvalHeight = this.$refs.approvalRight[0].$el.clientHeight
     setTimeout(() => {
      this.$nextTick(() => {
        htmlToPdf('#pdfTest', '用章申请审批单')
      })
     }, 1000);
    }
  },
  computed: {
    getMoneyFormat () {
      return cnMoneyFormat(this.info.feeAmount)
    },
    getToLocaleString () {
      const options = {
        style: 'currency',
        currency: 'CNY',
      };
      return (this.info.feeAmount).toLocaleString('zh-CN', options)
    }
  }
}
</script>
<style lang="scss" scoped>
.pdf-row {
  width: 1050px;
  padding: 40px 20px;
  box-sizing: border-box;
  font-weight: bold;
  position: relative;
  .top {
    height: 100px;
    text-align: center;
    font-size: 25px;
    line-height: 100px;
    font-weight: bold;
    background-image: url('~@/assets/images/gateway/logo.jpg');
    background-repeat: no-repeat;
    background-size: 100px 100px;
  }
  .barcode{
    position: absolute;
    right: 25px;
    top: 40px;
    bottom: 0;
  }
  .date {
    text-align: right;
    font-size: 20px;
  }
  .table-row {
    border: 1px solid #000;
    /deep/ .el-col {
      padding: 0px 10px;
      box-sizing: border-box;
      line-height: 45px;
      font-size: 16px;
    }
    .amount {
      text-align: center;
      // align-items: center;
      // line-height: normal;
      display: flex;
      flex-wrap:wrap;
      align-items: center;
      // min-height: 86px;
      box-sizing: border-box;
      // padding: 20px 0;
      div {
        width: 100%;
      }
    }
    .amount-value {
      // line-height: 40px;
      font-weight: bold;
      // padding: 20px 0;
    }
    .border-left {
      border-left: 1px solid #000;
    }
    .border-top {
      border-top: 1px solid #000;
    }
    .border-right {
      border-right: 1px solid #000;
    }
    .border-bottom {
      border-bottom: 1px solid #000;
    }
  }
}
</style>